import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4fa3b2db"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bigImg"
};
const _hoisted_2 = {
  class: "swiper-container swiperImg",
  ref: "swiperBigImg"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = {
  class: "swiper-slide"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "placeHolderImg",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$parent.showBigImg = false)
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.imgs, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_5)]);
  }), 256))]), _hoisted_6], 512)]);
}